import { render } from "./NewUserView.vue?vue&type=template&id=1c133f8d"
import script from "./NewUserView.vue?vue&type=script&lang=js"
export * from "./NewUserView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__